import { ICON_COLOR, LanguageIcon } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
export interface TranslationLanguagesBadgeProps {
  /** 번역 언어 목록 (예: ['ko', 'ja', 'en']) */
  languages: string[];
}

/**
 * TranslationLanguagesBadge - 퀴즈 번역 언어 배지
 *
 * @description
 * 퀴즈에서 지원하는 번역 언어 목록을 아이콘과 텍스트로 표시합니다.
 * - 아이콘: TranslationFill 아이콘 (16x16)
 * - 텍스트: 언어 코드를 대문자로 변환하여 표시 (예: "KO, JA, EN 번역")
 *
 * Figma Design Reference:
 * - Node ID: 28634:51864 (Mobile), 28634:51208 (Desktop)
 * - 스타일은 다른 배지와 동일하지만 텍스트는 body-sm-semibold (13px) 사용
 */
export const TranslationLanguagesBadge = ({
  languages
}: TranslationLanguagesBadgeProps) => {
  const {
    t
  } = useTranslation(['common']);

  // 언어 코드를 대문자로 변환하고 쉼표로 구분
  const languageText = languages.map(lang => lang.toUpperCase()).join(', ');
  return <div className="flex shrink-0 items-center gap-2xs" data-sentry-component="TranslationLanguagesBadge" data-sentry-source-file="TranslationLanguagesBadge.tsx">
      <div className="flex size-[16px] items-center justify-center">
        <LanguageIcon size="xs" fill={ICON_COLOR.neutral} data-sentry-element="LanguageIcon" data-sentry-source-file="TranslationLanguagesBadge.tsx" />
      </div>
      <p className="text-center text-caption-lg-semibold text-neutral">
        {t('aiTranslation.languages.code', {
        code: languageText
      })}
      </p>
    </div>;
};